import { useEffect, useState } from 'react';
export var Direction;
(function (Direction) {
    Direction[Direction["UP"] = 0] = "UP";
    Direction[Direction["DOWN"] = 1] = "DOWN";
})(Direction || (Direction = {}));
export default (function (_a) {
    var _b = _a === void 0 ? {} : _a, initialDirection = _b.initialDirection, thresholdPixels = _b.thresholdPixels, off = _b.off;
    var _c = useState(initialDirection), direction = _c[0], setDirection = _c[1];
    var _d = useState(true), isTop = _d[0], setIsTop = _d[1];
    useEffect(function () {
        var threshold = thresholdPixels || 0;
        var lastScrollY = window.pageYOffset;
        var ticking = false;
        var updateScrollDir = function () {
            var scrollY = window.pageYOffset;
            if (Math.abs(scrollY - lastScrollY) >= threshold) {
                setDirection(scrollY > lastScrollY ? Direction.DOWN : Direction.UP);
                lastScrollY = scrollY > 0 ? scrollY : 0;
            }
            setIsTop(scrollY <= threshold);
            ticking = false;
        };
        var onScroll = function () {
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDir);
                ticking = true;
            }
        };
        if (!off) {
            window.addEventListener('scroll', onScroll, { passive: true });
        }
        else {
            setDirection(initialDirection);
        }
        return function () { return window.removeEventListener('scroll', onScroll); };
    }, [initialDirection, thresholdPixels, off, setDirection, setIsTop]);
    return {
        isScrollingUp: direction === Direction.UP,
        isScrollingDown: direction === Direction.DOWN,
        isTop: isTop,
    };
});
//# sourceMappingURL=useScrollDirection.js.map